import React from 'react'
import { Box, useColorModeValue } from '@chakra-ui/react'
import { FaFilePdf } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { theme } from '../../theme/theme'
import styled from 'styled-components'
import SectionHeader from '../../components/SectionHeader'

const DownloadLink = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 14px 20px;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    border-radius: 4px;

    &:hover {
        background-color: ${theme.white};
        color: ${theme.blue};
    }
`

const Attachments = ({ attachments }) => {
    const { t } = useTranslation()
    const textColor = useColorModeValue('brand.dayTextColor', 'brand.nightTextColor')
    // const borderColor = useColorModeValue('brand.dayTextColor', 'brand.nightTextColor')

    return (
        attachments && (
            <Box mb={10}>
                <SectionHeader title={t('titles.attachments')} subtitle={t('subtitles.attachments')} />
                <Box py={4} px={14}>
                    {attachments?.map((attachment, index) => (
                        <Box
                            key={attachment.title}
                            color={textColor}
                            borderWidth={2}
                            borderStyle={'solid'}
                            // borderColor={borderColor}
                            display={'inline-block'}
                        >
                            <DownloadLink
                                key={index}
                                href={attachment.file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFilePdf size={'30'} /> &nbsp; {attachment.title}
                            </DownloadLink>
                        </Box>
                    ))}
                </Box>
            </Box>
        )
    )
}

export default Attachments
